<div class="container main-container">
    <h1 class="text-center">{{title}}</h1>
</div>
